import { render, staticRenderFns } from "./privacyAgree.vue?vue&type=template&id=b1def728&scoped=true"
import script from "./privacyAgree.vue?vue&type=script&lang=js"
export * from "./privacyAgree.vue?vue&type=script&lang=js"
import style0 from "./privacyAgree.vue?vue&type=style&index=0&id=b1def728&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1def728",
  null
  
)

export default component.exports